import React from "react";
import { Chip, Box } from "@mui/material";

/**
 * Reusable component for displaying status chips with colors
 * @param {string} statusCode - The status code to match against statusTypes
 * @param {Array} statusTypes - Array of status objects with grnstatuscode, grnstatus, colorcode
 * @param {boolean} clickable - Whether the chip should be clickable
 * @param {function} onClick - Click handler function
 * @param {Object} customStyles - Optional custom styles
 */
function StatusChip({
  statusCode,
  statusTypes = [],
  clickable = false,
  onClick = () => {},
  customStyles = {}
}) {
  const matchedStatus = statusTypes.find(
    (status) => String(status.grnstatuscode || status.trsts) === String(statusCode)
  );

  if (!matchedStatus) {
    return (
      <Chip
        label="Unknown"
        size="small"
        sx={{
          backgroundColor: "#ccc",
          color: "#fff",
          ...customStyles
        }}
        clickable={clickable}
        onClick={onClick}
      />
    );
  }

  return (
    <Chip
      label={matchedStatus.grnstatus || matchedStatus.trenuserremark || "Unknown"}
      sx={{
        backgroundColor: matchedStatus.colorcode || "#ccc",
        color: "#fff",
        ...customStyles
      }}
      size="small"
      clickable={clickable}
      onClick={onClick}
    />
  );
}

export default StatusChip;
